export default {
  methods: {
    cancel() {
      this.$router.push(`/${this.contentType.name}/list`)
    },
  },
}
